module.exports = __webpack_public_path__ + "img/1.c0747c6a.png";